import React, { useState } from "react";
import ReactModal from "react-modal";

import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import AlertListingItem from "./AlertListingItem";
import AlertListingTable from "./AlertListingTable";
import "./rc-alert-detail-modal.scss";

const TABS = [
  { id: "results", label: "Results", endpoint: "main_alert" },
  { id: "similar_listings", label: "Similar Listings", endpoint: "similar_listings" },
];

const IClose = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M1 1L13 13M13 1L1 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * RC OS v3 alert detail modal — replaces ItemDetail.jsx's cramped
 * inline-under-the-row panel with a proper ReactModal (react-modal
 * convention: rc-*-modal className / rc-*-modal-overlay overlayClassName,
 * full-screen mobile takeover below $bp-md).
 *
 * Counts for each tab come from the same InfiniteScroll fetch that loads the
 * table rows (via AlertListingTable's onResultsLoaded), instead of the two
 * duplicate `/main_alert` + `/similar_listings` count-only POSTs the legacy
 * component fired on every mount and every tab switch.
 */
const RCAlertDetailModal = ({ alertId, isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState("results");
  const [counts, setCounts] = useState({ results: null, similar_listings: null });

  const onTabResultsLoaded = (tabId) => (_, total) => {
    setCounts((prev) => ({ ...prev, [tabId]: total }));
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="rc-adm"
      overlayClassName="rc-adm-overlay"
    >
      <div className="rc-adm__header">
        <div className="rc-adm__tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`rc-adm__tab${tab.id === activeTab ? " rc-adm__tab--active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {counts[tab.id] != null && (
                <span className="rc-adm__tab-count">{counts[tab.id]}</span>
              )}
            </button>
          ))}
        </div>
        <button className="rc-adm__close" onClick={onClose} title="Close">
          <IClose />
        </button>
      </div>

      <div className="rc-adm__body">
        {TABS.map(
          (tab) =>
            tab.id === activeTab && (
              <AlertListingTable
                key={tab.id}
                className="rc-adm__table"
                fetchUrl={`/api/alert/${alertId}/listings/${tab.endpoint}`}
                headers={[
                  "Source",
                  "Date",
                  "Product",
                  "Title",
                  "Reference",
                  "Price",
                  "Country",
                ]}
                RowComponent={AlertListingItem}
                onResultsLoaded={onTabResultsLoaded(tab.id)}
              />
            )
        )}
      </div>
    </ReactModal>
  );
};

export default RCAlertDetailModal;
